import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../components/Main/Header/Header";
import Hero from "../components/Message/Hero/Hero";
import Form from "../components/Message/Form/Form";
import Survey from "../components/Message/Survey/Survey";
import Footer from "../components/Main/Footer/Footer";
import About from "../components/Message/About/About";
import Final from "../components/Message/Final/Final";

function ClientPage() {
  const { id, password } = useParams();
  const navigate = useNavigate();
  const [clientData, setClientData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    async function fetchClientData() {
      try {
        const response = await fetch(
          `https://lovnamek.ru/api/saved-data/${id}`
        );
        const data = await response.json();

        // Agar API 404 ni JSON da yuborsa yoki response.ok false bo‘lsa
        if (!response.ok || data.detail === "Not found.") {
          setErrorMessage("Данные не найдены."); // Rus tilida ogohlantirish
          // 2 sekunddan keyin bosh sahifaga yo'naltirish
          setTimeout(() => {
            navigate("/", { replace: true });
          }, 2000);
          return;
        }

        setClientData(data);
      } catch (error) {
        console.error("Xatolik yuz berdi:", error);
        setErrorMessage("Произошла ошибка при загрузке данных."); // Xatolik haqida ruschada
        setTimeout(() => {
          navigate("/", { replace: true });
        }, 2000);
      } finally {
        setLoading(false);
      }
    }

    if (id) {
      fetchClientData();
    }
  }, [id, navigate]);

  if (loading)
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "#ffe6f0", // pastel pushti
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "6px solid #ffcce0",
            borderTop: "6px solid #ff66a3",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            marginBottom: "20px",
          }}
        ></div>
        <p style={{ fontSize: "18px", color: "#d63384", fontWeight: "500" }}>
          Загрузка данных...
        </p>
      </div>
    );

  if (errorMessage)
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #ffe0e0, #fff5f5)",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #f5c2c7",
            padding: "30px 40px",
            borderRadius: "12px",
            boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
            maxWidth: "400px",
            textAlign: "center",
            animation: "fadeIn 0.6s ease-out",
          }}
        >
          <h2 style={{ color: "#dc3545", marginBottom: "10px" }}>⚠️ Ошибка</h2>
          <p style={{ fontSize: "16px", color: "#333" }}>{errorMessage}</p>
          <small style={{ color: "#555" }}>
            Через 2 секунды вы будете перенаправлены на главную страницу...
          </small>
        </div>
      </div>
    );

  if (!clientData) return null;

  return (
    <>
      <Header />
      <Hero clientData={clientData} />
      <About />
      <Form clientData={clientData} />
      <Survey clientData={clientData} password={password} />
      <Final />
      <Footer />
    </>
  );
}

export default ClientPage;
